// extracted by mini-css-extract-plugin
export var cardTitle = "_jf-1";
export var commentBubble = "_jf-e";
export var commentForm = "_jf-a";
export var commentInput = "_jf-b";
export var commentLabel = "_jf-d";
export var commentPrompt = "_jf-9";
export var csatCard = "_jf-0";
export var feedbackSection = "_jf-7";
export var starDisabled = "_jf-6";
export var starEmpty = "_jf-5";
export var starFilled = "_jf-4";
export var starWrapper = "_jf-3";
export var starsContainer = "_jf-2";
export var submittedComment = "_jf-c";
export var thankYouText = "_jf-8";